import { render, staticRenderFns } from "./transactionlist.vue?vue&type=template&id=6044ebc6&scoped=true"
import script from "./transactionlist.vue?vue&type=script&lang=js"
export * from "./transactionlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044ebc6",
  null
  
)

export default component.exports